import { apiAxios } from "../apiConfig";

export const createCheckoutSession = async (donationData) => {
  try {
    const response = await apiAxios.post("/donations/create-checkout", donationData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to connect to payment server" };
  }
};

export const getDonationStatus = async (sessionId) => {
  try {
    const response = await apiAxios.get(`/donations/status/${sessionId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to check donation status" };
  }
};
